import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import FeatureFlagger from 'src/app/FeatureFlagger/FeatureFlagger'
import HoverableLink from 'src/components/HoverableLink/HoverableLink'
import SvgTools from 'src/components/Svgs/SvgTools'
import { RemoteConfigIssue } from 'src/models/remoteConfig.models'
import { selectRemoteConfigFromState } from 'src/redux/selectors/session.selectors'
import { css } from 'styled-components'

const DevToolsButton: React.FC = (): React.ReactElement => {
  const remoteConfig = useSelector(selectRemoteConfigFromState)
  const configIssue = remoteConfig.configError !== RemoteConfigIssue.None

  const [isFlyoutOpen, setIsFlyoutOpen] = useState(false)

  return (
    <>
      <FeatureFlagger
        isOpen={isFlyoutOpen}
        onClose={() => setIsFlyoutOpen(false)}
      />
      <HoverableLink
        onClick={() => setIsFlyoutOpen(true)}
        ariaLabel="Dev tools"
      >
        <div
          data-testid="dev-tools-button"
          css={css`
            width: 110px;
            height: 110px;
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            border-radius: 50%;
            background-color: ${configIssue
              ? styleConstants.colors.red_light
              : styleConstants.colors.gray_light};
            border: 3px solid
              ${configIssue
                ? styleConstants.colors.red_darker
                : styleConstants.colors.gray_dark};
            box-shadow:
              0 4px 10px 0 rgba(0, 0, 0, 0.15),
              inset 0px 0px 0px 1px ${styleConstants.colors.gray_medium};
            cursor: pointer;

            &:hover {
              box-shadow:
                0 12px 20px 0 rgba(0, 0, 0, 0.15),
                inset 0px 0px 0px 2px ${styleConstants.colors.gray_medium};
            }

            &:hover .tooltip {
              display: block;
            }
          `}
        >
          <SvgTools
            css={css`
              transform: scale(0.75);
            `}
            fill={
              configIssue
                ? styleConstants.colors.red
                : styleConstants.colors.gray_darkest
            }
          />
          <div
            className="tooltip"
            css={css`
              display: none;
              position: fixed;
              background-color: ${styleConstants.colors.white};
              bottom: 35px;
              right: 130px;
              padding: 10px;
              border: 3px solid ${styleConstants.colors.gray_dark};
              border-radius: 10px;
              box-shadow:
                0 4px 10px 0 rgba(0, 0, 0, 0.15),
                inset 0px 0px 0px 1px ${styleConstants.colors.gray_medium};
              ${getFontCss(
                32,
                configIssue
                  ? styleConstants.colors.red
                  : themeConstants.colors.cta,
                styleConstants.fontFamilies.regular,
              )};
            `}
          >
            {configIssue
              ? 'Check console for issue with Firebase Remote Config'
              : 'Click to show dev tools'}
          </div>
        </div>
      </HoverableLink>
    </>
  )
}

export default DevToolsButton
